import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-marin-page',
  templateUrl: './marin-page.component.html',
  styleUrls: ['./marin-page.component.scss']
})
export class MarinPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
